module.exports = __webpack_public_path__ + "static/media/AlwynNewRounded_Bold.e2568975.woff";